// extracted by mini-css-extract-plugin
export default {"close-button":"SellDetailsComponent_close-button__p2pny"};